import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, map, take } from 'rxjs';
import { ROUTE_CONSTANTS } from '../constants/route.constant';
import { isPaywallUser } from '../utils/free-trial.util';
import { AuthApiService } from '@app/modules/auth/services/auth-api/auth-api.service';

/** Lets only free coaches onto the paywall; everyone else (paying, premium, admin) goes to the start page. */
@Injectable({ providedIn: 'root' })
export class PaywallGuard implements CanActivate {
    constructor(
        private readonly authService: AuthApiService,
        private readonly router: Router
    ) {}

    canActivate(): Observable<boolean | UrlTree> {
        return this.authService.user$.pipe(
            take(1),
            map((user) => (isPaywallUser(user) ? true : this.router.createUrlTree([ROUTE_CONSTANTS.HOME])))
        );
    }
}
